"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPluginUserAgent = exports.getUserAgent = void 0;
const node_async_hooks_1 = require("node:async_hooks");
const version_1 = require("../version");
const pluginUserAgentStorage = new node_async_hooks_1.AsyncLocalStorage();
const formatPluginName = (pluginName) => pluginName.replace(/^@datadog\//, '');
const formatPluginUserAgent = (pluginName, pluginVersion) => `${formatPluginName(pluginName)}/${pluginVersion}`;
// The user agent has the same format as the one used in the Datadog API client for TypeScript.
// https://github.com/DataDog/datadog-api-client-typescript/blob/507c098afb5224efe8bf4cbcd0e3d84fd2bc4525/userAgent.ts#L5
let baseUserAgent;
if (typeof process !== 'undefined' && process.release && process.release.name === 'node') {
    baseUserAgent = `datadog-ci/${version_1.cliVersion} (node ${process.versions.node}; os ${process.platform}; arch ${process.arch})`;
}
else {
    baseUserAgent = `datadog-ci/${version_1.cliVersion} (runtime unknown)`;
}
/**
 * Gets the user agent for requests made by the CLI.
 *
 * @example `datadog-ci/1.0.0 (node 18.17.0; os darwin; arch arm64) datadog-ci-plugin-synthetics/1.0.0`
 * @example `datadog-ci/1.0.0 (runtime unknown) datadog-ci-plugin-synthetics/1.0.0`
 * @example `datadog-ci/1.0.0 (runtime unknown)`
 */
const getUserAgent = () => {
    const activePlugin = pluginUserAgentStorage.getStore();
    if (activePlugin) {
        return `${baseUserAgent} ${activePlugin}`;
    }
    return baseUserAgent;
};
exports.getUserAgent = getUserAgent;
const withPluginUserAgent = (pluginName, pluginVersion, callback) => __awaiter(void 0, void 0, void 0, function* () { return pluginUserAgentStorage.run(formatPluginUserAgent(pluginName, pluginVersion), callback); });
exports.withPluginUserAgent = withPluginUserAgent;
//# sourceMappingURL=user-agent.js.map